/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbAssignmentGroup {
    getFixupPrototypeFunction() { return ServiceNowCmdbAssignmentGroup.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbAssignmentGroup>): ServiceNowCmdbAssignmentGroup {
        let obj = Object.assign(new ServiceNowCmdbAssignmentGroup(), model);
        ServiceNowCmdbAssignmentGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbAssignmentGroup>): ServiceNowCmdbAssignmentGroup {
        if (!model) return null;
        return ServiceNowCmdbAssignmentGroup.newInstance(<ServiceNowCmdbAssignmentGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbAssignmentGroup) {
        if (!obj) return;

        models.ServiceNowCmdbAssignmentGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbAssignmentGroup): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbAssignmentGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the ServiceNow User Group
     */
    name: string;

    /**
     * Sys_id of the ServiceNow User Group
     */
    sys_id: string;

}
